
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'

export default {
	name: 'SelectableParticipant',

	components: {
		AvatarWrapper,
	},

	props: {
		/**
		 * The participant object
		 */
		participant: {
			type: Object,
			required: true,
		},

		checked: {
			type: Array,
			required: true,
		},
	},

	emits: ['update:checked'],

	computed: {
		modelProxy: {
			get() {
				return this.checked
			},
			set(value) {
				this.$emit('update:checked', value)
			},
		},
	},
}
